import { styled } from '@mui/material/styles';
import { Loader as BaseLoader } from 'components/styledComponents';

const SPACING = 1.875;

export const ContentSection = styled('div')(({ theme, width, size }) => {
  let flexValue = '1 1'; // default

  if (width) {
    flexValue = `0 0 ${width}`;
  }
  if (size) {
    // overrides width if both provided
    flexValue = `${size} 1 calc((100% - 2 * ${theme.spacing(SPACING)}) / 12 * ${size})`;
  }

  return {
    flex: flexValue,
    margin: theme.spacing(1.5, 0)
  };
});

export const Loader = styled(BaseLoader)(() => ({
  paddingTop: '0px'
}));

export const LoaderContent = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap'
}));
